import BaseProxy from './BaseProxy';

class CourseMap extends BaseProxy {
    constructor(parameters = {}) {
        super('/api/v1/course/map', parameters);
    }
}

export default CourseMap;



// WEBPACK FOOTER //
// ./src/api/CourseMap.js